import { legacyMapSetContent } from './data/legacy-map-to-keditor';
import { morelessSetContent, morelessPreProcess } from './data/moreless';
import { attachmentPreProcess, attachmentSetContent } from './data/attachment';
import { daumblogAttachmentSetContent } from './data/daumblog-data';
import { sourcePreProcess, sourceSetContent } from './data/source';

const plugin = editor => {
  editor.on('BeforeSetContent', e => {
    e.content = attachmentSetContent(editor, e.content);
  });

  editor.on('SetContent', e => {
    legacyMapSetContent(editor, e);
    morelessSetContent(editor, e);
    sourceSetContent(editor, e);
    daumblogAttachmentSetContent(editor, e);
  });

  editor.on('PreProcess', e => {
    attachmentPreProcess(editor, e);
    morelessPreProcess(editor, e);
    sourcePreProcess(editor, e);
  });

  editor.on('PostProcess', e => {
  });
};

export default plugin;
